"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Component = function Component(element) {
  _classCallCheck(this, Component);

  this.dataset = element.dataset;
  this.element = element;
  this.state = {};
  this.init();
};

_defineProperty(Component, "findAll", function (componentName, init) {
  return _toConsumableArray(document.querySelectorAll("*[data-component=\"".concat(componentName, "\"]"))).map(init);
});

var ImageCutter =
/*#__PURE__*/
function (_Component) {
  _inherits(ImageCutter, _Component);

  function ImageCutter() {
    _classCallCheck(this, ImageCutter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageCutter).apply(this, arguments));
  }

  _createClass(ImageCutter, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$props, imageSrc, velocity, piecesCount, animate, image, amplitudeCompensator, app, containers;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.props = _objectSpread({}, ImageCutter.defaultProps, this.dataset);
                _this$props = this.props, imageSrc = _this$props.imageSrc, velocity = _this$props.velocity, piecesCount = _this$props.piecesCount;
                animate = parseInt(velocity, 10);
                PIXI.utils.skipHello();

                if (imageSrc) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                _context.next = 8;
                return this.getImage();

              case 8:
                image = this.state.image = _context.sent;
                amplitudeCompensator = image.naturalWidth > image.naturalHeight ? image.naturalWidth * this.props.amplitude / 50 : image.naturalHeight * this.props.amplitude / 50;
                app = this.state.app = new PIXI.Application(image.naturalWidth + amplitudeCompensator, image.naturalHeight + amplitudeCompensator, {
                  interactive: true,
                  transparent: true,
                  antialias: false
                });

                if (this.state.app.type == PIXI.WEBGL_RENDERER) {
                  console.log('Using WebGL');
                } else {
                  console.log('Using Canvas');
                }

                ;
                this.state.app.transparent = "true";
                this.element.appendChild(app.view);
                containers = this.state.containers = this.createContainers();
                containers.forEach(function (container, i) {
                  app.stage.addChild(container);
                });
                if (animate) this.movePieces();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "createContainers",
    value: function createContainers() {
      var _this$props2 = this.props,
          imageSrc = _this$props2.imageSrc,
          rotationAngle = _this$props2.rotationAngle,
          piecesCount = _this$props2.piecesCount;
      var app = this.state.app;
      var angleInRad = Math.acosh(Math.cosh(rotationAngle * Math.PI / 180));
      var simpleRotationAngle = angleInRad / Math.PI * 180;
      var lineLength = app.screen.height + app.screen.width;
      var isRight = simpleRotationAngle > 90 && simpleRotationAngle < 180 || simpleRotationAngle > 270 && simpleRotationAngle < 360;

      var getPoint = function getPoint(t) {
        var x = app.screen.width * t;
        var y = isRight ? app.screen.height * t : app.screen.height * (1 - t);
        return {
          x: x,
          y: y
        };
      };

      var piecesCount = parseInt(piecesCount, 10);
      return new Array(piecesCount).fill(1).map(function (_, pos) {
        var point1 = getPoint(pos / piecesCount);
        var point2 = getPoint((pos + 1) / piecesCount);
        var imageContainer = new PIXI.Container();
        var texture = new PIXI.Texture.fromImage(imageSrc);
        var car = new PIXI.Sprite(texture); //const car = PIXI.Sprite.fromImage(imageSrc);

        car.anchor.set(0.5);
        car.x = app.screen.width / 2;
        car.y = app.screen.height / 2;
        imageContainer.addChild(car);
        var mask = new PIXI.Graphics();
        mask.position.x = 0;
        mask.position.y = 0;
        mask.lineStyle(0);
        mask.beginFill(0xffffff, 0);
        mask.moveTo(point1.x + Math.cos(angleInRad + Math.PI) * lineLength, point1.y + Math.sin(angleInRad + Math.PI) * lineLength);
        mask.lineTo(point1.x + Math.cos(angleInRad) * lineLength, point1.y + Math.sin(angleInRad) * lineLength);
        mask.lineTo(point2.x + Math.cos(angleInRad) * lineLength, point2.y + Math.sin(angleInRad) * lineLength);
        mask.lineTo(point2.x + Math.cos(angleInRad + Math.PI) * lineLength, point2.y + Math.sin(angleInRad + Math.PI) * lineLength);
        imageContainer.addChild(mask);
        imageContainer.mask = mask;
        return imageContainer;
      });
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var imageSrc = this.props.imageSrc;
      return new Promise(function (res, rej) {
        var image = new Image();

        image.onload = function () {
          return res(image);
        };

        image.error = rej;
        image.src = imageSrc;
      });
    }
  }, {
    key: "movePieces",
    value: function movePieces() {
      var _this2 = this;

      var _this$props3 = this.props,
          velocity = _this$props3.velocity,
          rotationAngle = _this$props3.rotationAngle,
          amplitude = _this$props3.amplitude;
      var angleInRad = rotationAngle * Math.PI / 180;
      var app = this.state.app;
      var rvector = {
        x: Math.cos(angleInRad),
        y: Math.sin(angleInRad)
      };
      var step = 1 / velocity * 60;
      var t = 0.51;
      var tempT = 0.5;
      var movedTop = 0;
      var top = window.pageYOffset;
      var topOffset = this.getGlobalPosition(this.element);
      var randomizer = [];
      var that = this;
      var hovered = false;
      var isFired = false;
      var x;
      var y;
      var elementWidth = that.element.offsetWidth;
      var elementHeight = that.element.offsetHeight;
      isFired = false;
      var target = this.element;
      var hoveredT = 0.5;
      var time2;
      var parentOffset = {
        top: 1,
        left: 1
      };
      var relX = 0.5;
      var relY = 0.5;

      if (elementHeight === 0) {
        elementHeight = app.screen.Height * 0.6;
      }

      var once = function once(f) {
        isFired = false;
        return function () {
          if (!isFired) {
            f();
            isFired = true;
          }
        };
      };

      var randomizeNumbers = once(function () {
        _this2.state.containers.forEach(function (container, i) {
          randomizer[i] = getRndInteger(1, 100);
        });
      });
      randomizeNumbers();

      if (window.innerWidth > 1040) {
        var resetTimer = function resetTimer() {
          clearTimeout(time2);
          time2 = setTimeout(resetHoveredT, 1000);
        };

        var resetHoveredT = function resetHoveredT() {
          if (hovered) {
            randomizeNumbers();
          }

          hoveredT = 0.5;
        };

        $(target).mouseenter(function () {
          hoveredT = 0.5;
          hovered = !hovered;
          var tempOffset = $(this).offset();

          if (tempOffset.left != 0) {
            parentOffset.left = tempOffset.left;
          } else {
            parentOffset.left = 1;
          }

          parentOffset.top = tempOffset.top;
        });
        $(target).mouseleave(function () {
          randomizeNumbers();
          isFired = false;
          hovered = !hovered;
          hoveredT = 0.5;
          relX = 0.5;
          relY = 0.5;
        });
        $(target).mousemove(function (event) {
          //relX = (event.pageX - parentOffset.left) / (elementWidth / 1.1);
          relY = (event.pageY - parentOffset.top) / (elementHeight / 1.2);
          resetTimer();
          hoveredT = relX - relY + 0.5;

          if (hoveredT <= 0.53 && hoveredT >= 0.48) {
            randomizeNumbers();
          }
        });
      } else {}

      this.state.app.ticker.add(function (delta) {
        top = window.pageYOffset / 500;

        if (0.48 <= t && t <= 0.52 && t != 0.51 && !hovered) {
          tempT = top + 1.32 - topOffset.y / 500;
          t = 0.5; //randomizeNumbers();

          if (tempT > 0.8 || tempT < 0.2) {
            t = tempT;
            tempT = 0.51;
          }
        } else {
          isFired = false;
          t = top + 1.32 - topOffset.y / 500;
        }

        if (hovered) {
          t = hoveredT;
        }

        _this2.state.containers.forEach(function (container, i) {
          var position = randomizer[i] % 2 ? getPosition(t) : getPosition(1 - t);
          TweenMax.to(container.position, 1.5, {
            x: position.x * randomizer[i] / 100,
            y: position.y * randomizer[i] / 100,
            ease: Power3.easeOut
          });
        });
      });
      $('a.menu-burger, .js-footer-open-menu').click(function (e) {
        if ($("a.menu-burger").hasClass("is-open")) {
          that.state.app.stop();
        } else {
          that.state.app.start();
        }
      });

      var getPosition = function getPosition(t) {
        var width = _this2.state.image.naturalWidth;
        return {
          x: amplitude * (1 - 2 * t) * rvector.x * width / 100,
          y: amplitude * (1 - 2 * t) * rvector.y * width / 100
        };
      };
    }
  }, {
    key: "getGlobalPosition",
    value: function getGlobalPosition(element) {
      var xPosition = 0;
      var yPosition = 0;

      while (element) {
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent;
      }

      return {
        x: xPosition,
        y: yPosition
      };
    }
  }]);

  return ImageCutter;
}(Component);

_defineProperty(ImageCutter, "findAll", function () {
  return Component.findAll('image-cutter', function (element) {
    return new ImageCutter(element);
  });
});

_defineProperty(ImageCutter, "defaultProps", {
  rotationAngle: 60,
  piecesCount: 5,
  velocity: 3500,
  amplitude: 10
});



var BackgroundImage =
/*#__PURE__*/
function (_Component4) {
  _inherits(BackgroundImage, _Component4);

  function BackgroundImage() {
    _classCallCheck(this, BackgroundImage);

    return _possibleConstructorReturn(this, _getPrototypeOf(BackgroundImage).apply(this, arguments));
  }

  _createClass(BackgroundImage, [{
    key: "init",
    value: function () {
      var _init4 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var imageSrc, image, app, container, currentFilter, time, totalHeight, totalWidth, backgroundAutoMovement, resetTimer;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                resetTimer = function _ref2() {
                  clearTimeout(time);
                  time = setTimeout(backgroundAutoMovement, 1500); // 1000 milliseconds = 1 second
                };

                backgroundAutoMovement = function _ref() {
                  var widthTimeline = new TimelineMax({});
                  var heightTimeline = new TimelineMax({});
                  widthTimeline.to(currentFilter.center, 5.64, {
                    x: totalWidth
                  }).to(currentFilter.center, 5.64, {
                    x: 0,
                    repeat: -1,
                    yoyo: true
                  });
                  heightTimeline.to(currentFilter.center, 5.04, {
                    y: totalHeight
                  }).to(currentFilter.center, 5.04, {
                    y: 0,
                    repeat: -1,
                    yoyo: true
                  });
                };

                this.props = _objectSpread({}, BackgroundImage.defaultProps, this.dataset);
                imageSrc = this.props.imageSrc;

                if (imageSrc) {
                  _context4.next = 6;
                  break;
                }

                return _context4.abrupt("return");

              case 6:
                _context4.next = 8;
                return this.getImage();

              case 8:
                image = this.state.image = _context4.sent;
                app = this.state.app = new PIXI.Application(image.naturalWidth, image.naturalHeight, {
                  interactive: false,
                  transparent: false,
                  antialias: false
                });
                app.stage.interactive = true;
                this.element.appendChild(app.view);
                container = this.createContainer();
                currentFilter = this.setFiltersFirst();
                container.filters = [currentFilter];
                app.stage.addChild(container);
                this.mouseEvents(currentFilter); //5.64

                document.onmousemove = resetTimer;
                document.onkeypress = resetTimer;
                totalHeight = app.screen.height;
                totalWidth = app.screen.width;
                $(document).ready(function () {
                  backgroundAutoMovement();
                  setTimeout(function () {
                    if (fps < 50) {
                      app.destroy(true, true);
                      console.log("background canvas removed for better perfomance");
                    }
                  }, 2300);
                });

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function init() {
        return _init4.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "createContainer",
    value: function createContainer() {
      var imageSrc = this.props.imageSrc;
      var app = this.state.app;
      var imageContainer = new PIXI.Container();
      var car = PIXI.Sprite.fromImage(imageSrc);
      car.anchor.set(0.5);
      car.x = app.screen.width / 2;
      car.y = app.screen.height / 2;
      imageContainer.addChild(car); //imageContainer.interactive = true;

      return imageContainer;
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var imageSrc = this.props.imageSrc;
      return new Promise(function (res, rej) {
        var image = new Image();

        image.onload = function () {
          return res(image);
        };

        image.error = rej;
        image.src = imageSrc;
      });
    }
  }, {
    key: "setFiltersFirst",
    value: function setFiltersFirst() {
      var app = this.state.app;
      var filter = new PIXI.filters.ZoomBlurFilter(); //filter.radius = (app.screen.width + app.screen.height) / 2;

      filter.strength = 0.2;
      filter.center.x = app.screen.width;
      filter.center.y = app.screen.height;
      filter.innerRadius = 100;
      return filter;
    }
  }, {
    key: "mouseEvents",
    value: function mouseEvents(event) {
      var app = this.state.app;
      app.stage.on('mousemove', onPointerMove);

      function onPointerMove(eventData) {
        TweenMax.to(event.center, 0.7, {
          x: eventData.data.global.x,
          y: eventData.data.global.y,
          onUpdate: function onUpdate() {},
          onComplete: function onComplete() {} //ease:Circ.easeIn,

        });
      }
    }
  }]);

  return BackgroundImage;
}(Component);

_defineProperty(BackgroundImage, "findAll", function () {
  return Component.findAll('background-image', function (element) {
    return new BackgroundImage(element);
  });
});

_defineProperty(BackgroundImage, "defaultProps", {});

window.onload = function () {
  ImageCutter.findAll();

  /*if (window.innerWidth > 1040) {
    BackgroundImage.findAll();
  }

  if (window.innerWidth > 1040) {
    CuttedMenu.findAll();
  }*/

  loaderToggle();
  formUpdate();
};

function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var scrollToTop = function scrollToTop() {
  var c = document.documentElement.scrollTop || document.body.scrollTop;

  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 15);
  }
};


var demo3;
var globalFrontReinit;
var contactFormUpdate;
$(document).ready(function () {
  var Demo3 =
  /*#__PURE__*/
  function () {
    function Demo3() {
      _classCallCheck(this, Demo3);

      var that = this;
      that.initCursor();
      that.initHovers();
    }

    _createClass(Demo3, [{
      key: "initCursor",
      value: function initCursor() {
        var _this6 = this;

        var _window = window,
            Back = _window.Back;
        this.outerCursor = document.querySelector(".circle-cursor--outer");
        this.innerCursor = document.querySelector(".circle-cursor--inner"); //this.outerCursorBox = this.outerCursor.getBoundingClientRect();

        this.outerCursorBox = {
          bottom: 42,
          height: 42,
          left: 0,
          right: 42,
          top: 0,
          width: 42,
          x: 0,
          y: 0
        };
        this.outerCursorSpeed = 0;
        this.easing = Back.easeOut.config(1.7);
        this.clientX = -100;
        this.clientY = -100;
        this.showCursor = false;
        this.tl = new TimelineMax({});

        var unveilCursor = function unveilCursor() {
          TweenMax.set(_this6.outerCursor, {
            x: _this6.clientX - _this6.outerCursorBox.width / 2,
            y: _this6.clientY - _this6.outerCursorBox.height / 2
          });
          _this6.showCursor = true;
        };

        document.addEventListener("mousemove", unveilCursor);
        document.addEventListener("mousemove", function (e) {
          _this6.clientX = e.clientX;
          _this6.clientY = e.clientY;
        });

        var render = function render() {
          TweenMax.set(_this6.innerCursor, {
            x: _this6.clientX,
            y: _this6.clientY
          });

          if (!_this6.isStuck) {
            TweenMax.to(_this6.outerCursor, _this6.outerCursorSpeed, {
              x: _this6.clientX - _this6.outerCursorBox.width / 2,
              y: _this6.clientY - _this6.outerCursorBox.height / 2
            });
          }

          if (_this6.showCursor) {
            document.removeEventListener("mousemove", unveilCursor);
          }

          requestAnimationFrame(render);
        };

        requestAnimationFrame(render);
      }
    }, {
      key: "initHovers",
      value: function initHovers() {
        var _this7 = this;

        var handleMouseEnter = function handleMouseEnter(e) {
          _this7.outerCursorOriginals = {
            width: 42,
            height: 42
          };

          _this7.tl.to(_this7.outerCursor, 0.3, {
            width: 132,
            height: 132,
            top: -40,
            left: -40,
            ease: Power1.easeInOut
          }).to(_this7.outerCursor, 0.6, {
            width: 100,
            height: 100,
            top: -30,
            left: -30,
            repeat: 100,
            ease: Power1.easeInOut,
            yoyo: true
          });
        };

        var handleMouseLeave = function handleMouseLeave() {
          _this7.tl.progress(1);

          _this7.tl.to(_this7.outerCursor, 0.3, {
            width: 42,
            height: 42,
            top: 0,
            left: 0
          });
        };

        var linkItems = document.querySelectorAll("a:not(.halfed), button:not(.halfed), .cursor-change");
        linkItems.forEach(function (item) {
          item.addEventListener("mouseenter", handleMouseEnter);
          item.addEventListener("mouseleave", handleMouseLeave);
        });

        var handleHalfMouseEnter = function handleHalfMouseEnter(e) {
          _this7.outerCursorOriginals = {
            width: _this7.outerCursorBox.width,
            height: _this7.outerCursorBox.height
          };

          _this7.tl.to(_this7.outerCursor, 0.3, {
            width: 80,
            height: 80,
            top: -15,
            left: -15,
            ease: Power1.easeInOut
          }).to(_this7.outerCursor, 0.6, {
            width: 64,
            height: 64,
            top: -10,
            left: -10,
            repeat: 100,
            ease: Power1.easeInOut,
            yoyo: true
          });
        };

        var halfLinkItems = document.querySelectorAll("a.halfed:not(.unhoverable), .halfed");
        halfLinkItems.forEach(function (item) {
          item.addEventListener("mouseenter", handleHalfMouseEnter);
          item.addEventListener("mouseleave", handleMouseLeave);
        });
        var goldenHoverTween = TweenMax.to(this.outerCursor, 0.3, {
          borderColor: "#353535",
          ease: this.easing,
          paused: true
        });

        var goldenMouseEnter = function goldenMouseEnter() {
          TweenMax.to(_this7.outerCursor, 0.2, {
            borderColor: "#353535"
          });
        };

        var goldenMouseLeave = function goldenMouseLeave() {
          TweenMax.to(_this7.outerCursor, 0.2, {
            //backgroundColor: "#a6884b",
            borderColor: "#a6884b"
          });
        };

        var goldenCursor = document.querySelectorAll(".skew-banner, .js-cursor-grey");
        goldenCursor.forEach(function (item) {
          item.addEventListener("mouseenter", goldenMouseEnter);
          item.addEventListener("mouseleave", goldenMouseLeave);
        });
      }
    }]);

    return Demo3;
  }();

  var clientX = -100;
  var clientY = -100;
  var innerCursor = document.querySelector(".cursor--small");

  var initCursor = function initCursor() {
    document.addEventListener("mousemove", function (e) {
      clientX = e.clientX;
      clientY = e.clientY;
    });

    var render = function render() {
      TweenMax.set(innerCursor, {
        x: clientX,
        y: clientY
      });
      requestAnimationFrame(render);
    };

    requestAnimationFrame(render);
  };

  initCursor();
  var lastX = 0;
  var lastY = 0;
  var isStuck = false;
  var showCursor = false;
  var group, stuckX, stuckY, fillOuterCursor;

  var initHovers = function initHovers() {
    // find the center of the link element and set stuckX and stuckY
    // these are needed to set the position of the noisy circle
    var handleMouseEnter = function handleMouseEnter(e) {
      var navItem = e.currentTarget;
      var navItemBox = navItem.getBoundingClientRect();
      stuckX = Math.round(navItemBox.left + navItemBox.width / 2);
      stuckY = Math.round(navItemBox.top + navItemBox.height / 2);
      isStuck = true;
    }; // reset isStuck on mouseLeave


    var handleMouseLeave = function handleMouseLeave() {
      isStuck = false;
    }; // add event listeners to all items


    var linkItems = document.querySelectorAll(".link");
    linkItems.forEach(function (item) {
      item.addEventListener("mouseenter", handleMouseEnter);
      item.addEventListener("mouseleave", handleMouseLeave);
    });
  };

  initHovers();
  demo3 = new Demo3();

  globalFrontReinit = function globalFrontReinit() {
    demo3.initHovers();
    demo3.initCursor();
    console.log("functions Reinit");
    var offsetHeader = $(".homepage-header__image__overlay").height();
    $("html, body").animate({
      scrollTop: offsetHeader
    }, 1000, function () {
      $('form input:text').first().focus();
    });
  };

  contactFormUpdate = function contactFormUpdate() {
    demo3.initHovers();
    demo3.initCursor();
  };
});



